import fi from "./fi";
import en from "./en";
import sv from "./sv";

export default {
  fi,
  en,
  sv
}
